import React, { Component } from 'react';
import { connect } from "react-redux";
import TimeAgo from "react-timeago";
import {messageReplace} from "../../lib/helper"

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class CenterMessage extends Component {

    constructor(props) {
        super(props);
		
		this.convertDate=this.convertDate.bind(this);
    }
	
	convertDate(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = (a.getMonth() < 10 ? '0':'')+a.getMonth();
  var date = (a.getDate() < 10 ? '0':'')+a.getDate();
  var hour = (a.getHours() < 10 ? '0':'')+a.getHours();
  var min = (a.getMinutes() < 10 ? '0':'')+a.getMinutes();
  var sec = (a.getSeconds() < 10 ? '0':'')+a.getSeconds();
  var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min;
  return time;
    }

    render() {
        const { t } = this.props;

        if(this.props.message.message_type=="text") {

            return (
                <div className="chat-line">
                    <span className="chat-date">{this.convertDate(this.props.message.message_time)}</span>
                    <div className="chat-system-message" dangerouslySetInnerHTML={{__html: messageReplace(this.props.message.message)}}>

                    </div>
                </div>
            )
        }
        else {
            return null;
        }

    }
}

export default CenterMessage;




